module.exports = __webpack_public_path__ + "static/media/science.290ddcae.jpg";